import React from 'react';
import IconGrowthDown from '../../icons/icon-grouth-down';
import IconGrowthUp from '../../icons/icon-growth-up';
export default function CardTotal({ title, total, growthTitle, icon, change_percent = 0, isDown = false }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative flex border rounded-3xl p-8 bg-white"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-1 flex-col justify-between gap-12"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-gray text-2xl"
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "font-bold text-4xl"
    }, total), /*#__PURE__*/ React.createElement("div", {
        className: "flex description"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex text-xl gap-2 items-center"
    }, isDown ? /*#__PURE__*/ React.createElement(IconGrowthDown, null) : /*#__PURE__*/ React.createElement(IconGrowthUp, null), /*#__PURE__*/ React.createElement("span", {
        className: isDown ? 'text-red-600' : 'text-green-400'
    }, change_percent, "%"), /*#__PURE__*/ React.createElement("span", {
        className: "text-gray font-medium"
    }, growthTitle)))), /*#__PURE__*/ React.createElement("div", {
        className: "absolute top-6 right-6 w-12 h-12 flex items-center justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "scale-75"
    }, icon)));
}
